import http from '../../core/services/http'

export const generateScrapingClustersReport = () =>
  http.get(`/reports/scraping-clusters/`, { responseType: 'blob' })
